import { combineReducers } from 'redux';
import { basketOptimizerReducer } from 'state/advisory/basket-optimizer/reducer';
import type { AdvisoryState } from 'state/advisory/model';

export const advisoryReducer = combineReducers<AdvisoryState>({
  basketOptimizer: basketOptimizerReducer,
});
